import FadeSlider from './fade-slider';

export default FadeSlider;
